import { render, staticRenderFns } from "./TeachBehaviorAnalysis.vue?vue&type=template&id=c24a7526&scoped=true"
import script from "./TeachBehaviorAnalysis.vue?vue&type=script&lang=js"
export * from "./TeachBehaviorAnalysis.vue?vue&type=script&lang=js"
import style0 from "./TeachBehaviorAnalysis.vue?vue&type=style&index=0&id=c24a7526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24a7526",
  null
  
)

export default component.exports